module.exports = __webpack_public_path__ + "img/base_nature_domaine_viticole.23ae67d0.svg";